export const LOAD_LABEL_REVIEW_INCI_DATA = 'labelReviewInciWizard/LOAD_LABEL_REVIEW_INCI_DATA';
export const COMMENT_EDITED = 'labelReviewInciWizard/COMMENT_EDITED';
